import Vue from "vue";
import moment from "moment";
// import App from "./App.vue";
// import Auth from "./Auth.vue";
import router from "./router";
import store from "./store";

require("@/assets/css/main.css");
require("../public/css/venuzle.css");

window.templateLabels = {};
window.apiBaseUrl = process.env.VUE_APP_API_URL
  ? process.env.VUE_APP_API_URL
  : "http://localhost:8084/";

console.log("API_URL:" + process.env.VUE_APP_API_URL);

window.VueEvent = new Vue();

Vue.config.productionTip = false;
Vue.prototype.$label = function(label, defaultText) {
  if (Object.prototype.hasOwnProperty.call(window.templateLabels, label)) {
    return window.templateLabels[label];
  }

  if (defaultText) {
    return defaultText;
  }

  return label;
};

Vue.prototype.$partnerEndpoint = function(path) {
  let partnerId = localStorage.partnerId;

  if (!partnerId) {
    if (window.location.pathname != "/login") {
      window.location.replace("/login");
    }
    return;
  }

  return "/api/internal/v1/partners/" + partnerId + "/" + path;
};

Vue.prototype.$appConfigs = () => {
  return window.appConfigs;
};

Vue.prototype.$moment = moment;

var VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo);

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = event => {
      if (!(el === event.target || el.contains(event.target))) {
        event.stopPropagation();
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
    el.clickOutsideEvent = null;
  }
});

Vue.mixin({
  methods: {
    beautifyName(firstname, lastname) {
      if (lastname == "" || lastname == null) {
        return firstname;
      }
      return lastname + ", " + firstname;
    },

    getGenderName(genderCode) {
      if (genderCode === 1 || genderCode === "1") {
        if (
          Object.prototype.hasOwnProperty.call(
            window.templateLabels,
            "common.gender_male"
          )
        ) {
          return window.templateLabels["common.gender_male"];
        }
        return "Male";
      } else if (genderCode === 2 || genderCode === "2") {
        if (
          Object.prototype.hasOwnProperty.call(
            window.templateLabels,
            "common.gender_female"
          )
        ) {
          return window.templateLabels["common.gender_female"];
        }
        return "Female";
      }
    },

    dateObjectToString(date) {
      return (
        (date.getDate() > 9 ? "" : "0") +
        date.getDate() +
        "." +
        (date.getMonth() + 1 > 9 ? "" : "0") +
        (date.getMonth() + 1) +
        "." +
        date.getFullYear()
      );
    },

    convertDate(prop, obj) {
      if (
        prop != null &&
        Object.prototype.toString.call(prop) === "[object Date]"
      ) {
        // Convert date object to date string
        return (
          prop.getFullYear() +
          "-" +
          (prop.getMonth() + 1 > 9 ? "" : "0") +
          (prop.getMonth() + 1) +
          "-" +
          (prop.getDate() > 9 ? "" : "0") +
          prop.getDate()
        );
      } else if (prop != null && obj != null) {
        // Convert date string to date object
        let parts = prop.split("-");
        return new Date(parts[0], parts[1] - 1, parts[2]);
      } else if (prop != null && obj == null) {
        // Convert date string format
        let parts = prop.split(".");
        return parts[2] + "-" + parts[1] + "-" + parts[0];
      }
    },

    convertDateTime(prop, obj) {
      if (
        prop != null &&
        Object.prototype.toString.call(prop) === "[object Date]"
      ) {
        // Convert datetime object to datetime string
        return (
          prop.getFullYear() +
          "-" +
          (prop.getMonth() + 1 > 9 ? "" : "0") +
          (prop.getMonth() + 1) +
          "-" +
          (prop.getDate() > 9 ? "" : "0") +
          prop.getDate() +
          " " +
          (prop.getHours() > 9 ? "" : "0") +
          prop.getHours() +
          ":" +
          (prop.getMinutes() > 9 ? "" : "0") +
          prop.getMinutes() +
          ":" +
          (prop.getSeconds() > 9 ? "" : "0") +
          prop.getSeconds()
        );
      } else if (prop != null && obj != null) {
        // Convert datetime string to datetime object
        let parts = prop.split(" ");
        let dateParts = parts[0].split("-");
        let timeParts = parts[1].split(":");
        return new Date(
          dateParts[0],
          dateParts[1] - 1,
          dateParts[2],
          timeParts[0],
          timeParts[1],
          timeParts[2]
        );
      } else if (prop != null && obj == null) {
        // Convert datetime string format
        let parts = prop.split(" ");
        let dateParts = parts[0].split(".");
        return (
          dateParts[2] +
          "-" +
          dateParts[1] +
          "-" +
          dateParts[0] +
          " " +
          parts[1]
        );
      }
    }
  }
});

var baseTemplate = null;

new Vue({
  router,
  store,

  data() {
    return {
      authRelatedRoutes: ["Login", "Register"]
    };
  },

  created() {
    this.checkLogin();

    router.beforeEach((to, from, next) => {
      this.checkLogin(to.name);
      next();
    });
  },

  render: h => h(baseTemplate),

  methods: {
    checkLogin(routeName = null) {
      if (!routeName) {
        routeName = this.$route.name;
      }

      if (this.isAuthRelatedRoute(routeName)) {
        baseTemplate = require("@/Auth.vue").default;
      } else {
        baseTemplate = require("@/App.vue").default;
      }

      this.$forceUpdate();
    },

    isAuthRelatedRoute(routeName) {
      return this.authRelatedRoutes.indexOf(routeName) !== -1;
    }
  }
}).$mount("#app");
